import styled from '@emotion/styled';

import Button from '../Button';
import type { ToggleButtonVariant } from './types';

// Every state keeps a 1px border so the box does not grow or shrink when the fill
// (which Button draws without a border) replaces the outline.
export const StyledToggleButton = styled(Button, {
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<{ $selected: boolean; $variant: ToggleButtonVariant }>(({ theme, $selected, $variant }) => ({
  ...(!$selected && {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  }),
  ...($selected && {
    border: `1px solid ${$variant === 'solid' ? theme.colors.border.default : 'transparent'}`,
  }),
}));
